import { Box, FormControl, Grid } from "@mui/material";

import { InputController, InputNumberFormatController, InputDatePickerController } from "@shared/ui/form";
import UploadFile from "@vendor/examples/UploadFile";

import type { ChangeEvent } from "react";
import type { Control, FieldErrors } from "react-hook-form";
import type { TFunction } from "i18next";
import type { ManualInvoiceFormValues } from "../lib/invoicePayloads";

export interface ChargedAutomaticProps {
    errors: FieldErrors<ManualInvoiceFormValues>;
    control: Control<ManualInvoiceFormValues>;
    file: File | undefined;
    handleChangeFile: (e: ChangeEvent<HTMLInputElement>) => void;
    validateFile: { required: boolean; type: boolean; size: boolean };
    t: TFunction;
}

export const ChargedAutomatic = ({ errors, control, file, handleChangeFile, validateFile, t }: ChargedAutomaticProps) => {
    return (
        <>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputController name="invoiceNumber" control={control}
                        type="number"
                        defaultValue="" label={t("invoiceNumber")} />
                    {errors.invoiceNumber &&
                        <span
                            style={{ fontSize: 12, color: "red" }}>{errors.invoiceNumber.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth>
                    {/* `type` no es una prop de `InputNumberFormatController` (nunca se leía en runtime); se
                        quita acá porque JSX ahora la rechaza, sin cambio de comportamiento. */}
                    <InputNumberFormatController name="subtotal" control={control}
                        defaultValue="" label={t("subTotal")} />
                    {errors.subtotal &&
                        <span style={{ fontSize: 12, color: "red" }}>{errors.subtotal.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputNumberFormatController name="itbmsTax" control={control}
                        defaultValue="" label="ITBMS" />
                    {errors.itbmsTax &&
                        <span style={{ fontSize: 12, color: "red" }}>{errors.itbmsTax.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputNumberFormatController name="total" control={control}
                        defaultValue="" label={t("total")} />
                    {errors.total &&
                        <span style={{ fontSize: 12, color: "red" }}>{errors.total.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputController name="ccEmail" control={control}
                        type="email"
                        defaultValue="" label={t("ccEmail")} />
                    {errors.ccEmail &&
                        <span style={{ fontSize: 12, color: "red" }}>{errors.ccEmail.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputDatePickerController
                        control={control}
                        defaultValue={new Date()}
                        openTo='month'
                        name="invoiceDate"
                        label={t("invoiceDate")}
                        views={['year', 'month', 'day']}
                    />
                    {errors.invoiceDate &&
                        <span style={{ fontSize: 12, color: "red" }}>{errors.invoiceDate.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputController name="comments" control={control}
                        type="string"
                        defaultValue="" label={t("comments")} />
                    {errors.comments &&
                        <span
                            style={{ fontSize: 12, color: "red" }}>{errors.comments.message}</span>}
                </FormControl>
            </Grid>
            <Grid size={12}>
                <Box sx={{mb: 2}}>
                    <UploadFile
                        id="coverPage"
                        nameInput="cover"
                        onChangeFile={handleChangeFile}
                        file={file}
                        textButton={t("loadInvoice")}
                        fileLoaded={t("loadedInvoice")}
                    />
                    {validateFile.size &&
                        <span style={{ fontSize: 12, color: "red" }}>{t("maximumFileSizeInvoice")}</span>}
                    {validateFile.type &&
                        <span style={{ fontSize: 12, color: "red" }}>{t("allowedFormatInvoice")}</span>}
                    {validateFile.required &&
                        <span style={{ fontSize: 12, color: "red" }}>{t("isRequired")}</span>}
                </Box>
            </Grid>
        </>
    );
}
